<template>
  <div
    class="bg-neutral-500 min-h-full min-h-dvh min-h-svh flex flex-col items-center justify-center"
  >
    <div class="bg-white shadow-md rounded-lg p-6 w-full max-w-full md:max-w-md lg:max-w-lg">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
